export default "__VITE_ASSET__CgLqvcpp__"